import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ProductApiService } from 'src/app/services/api/product-api.service';
import { PreSales2ModalComponent } from '../pre-sales2-modal/pre-sales2-modal.component';
import { PreSales1ModalComponent } from '../pre-sales1-modal/pre-sales1-modal.component';
@Component({
  selector: 'app-platform-tab-list-sversion',
  templateUrl: './platform-tab-list-sversion.component.html',
  styleUrls: ['./platform-tab-list-sversion.component.scss'],
})
export class PlatformTabListSversionComponent implements OnInit {
  constructor(
    private api: ProductApiService,
    private modal: MatDialog,
    private modalRef: MatDialogRef<PreSales1ModalComponent>
  ) {}

  ngOnInit(): void {
    this.findPlatformCategories();
  }

  categories: any[] = [];
  loading = false;
  async findPlatformCategories() {
    try {
      this.loading = true;
      const r = await this.api.findPlatformCategories();
      this.categories = r.data;
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }

  openPlatformModal(data: any) {
    this.modalRef.close();
    this.modal.open(PreSales2ModalComponent, {
      width: '712px',
      data: data,
    });
  }
}
